import React from "react";
import { Link } from "react-router-dom";

/**
 * Official NOVANEXT logo — always uses the exact source file provided by the client.
 * Never redraw, never recolor, never change proportions.
 *   variant="full"  → building + wordmark + baseline
 *   variant="icon"  → building symbol only (favicon-like)
 */
export const Logo = ({ variant = "full", height = 44, className = "", asLink = true }) => {
  const src =
    variant === "icon"
      ? "/brand/novanext-icon.png"
      : "/brand/novanext-logo-tight.png";

  const img = (
    <img
      src={src}
      alt="NOVANEXT SERVICES GÉNÉRAUX"
      style={{ height: `${height}px`, width: "auto" }}
      className={`select-none pointer-events-none ${className}`}
      draggable={false}
      data-testid="nx-logo"
    />
  );

  if (!asLink) return img;
  return (
    <Link to="/" aria-label="NOVANEXT — Accueil" data-testid="nx-logo-link">
      {img}
    </Link>
  );
};

export default Logo;
